import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ProgressStatus {
  Header = "Progress Status";
  _sent = [
    "Sending the carrier pidgeons...",
    "Reticulating splines...",
    "Analyzing inputs...",
    "Computerizing your request..."
  ];
  _received = [
    "Data received. Churning...",
    "Sorting through the bits...",
    "Layin' it all out for ya...",
    "Transmogrifying the stuff..."
  ];

  getSentMessage(): string {
    return this._sent[Math.floor(Math.random() * this._sent.length)];
  }

  getReceivedMessage(): string {
    return this._received[Math.floor(Math.random() * this._received.length)];
  }
}
